
export function Services() {
  const services = [
    {
      icon: 'ri-file-search-line',
      title: 'Compliance and eligibility review',
      description: 'We review your city rules, zoning, and strata bylaws and tell you clearly what is allowed and what is not. No guesswork, just facts.',
      featured: true,
      link: '/compliance-review'
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Short-term rental co-hosting',
      description: 'For qualifying owner-occupied homes. We handle licensing setup, listing management, guest communication, pricing, and operations.',
      featured: false,
      link: '/str-cohosting'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Medium-term furnished rentals',
      description: 'Fully furnished rentals for 3 to 6 months. Ideal for owners who want fewer turnovers and no short-term rental licensing.',
      featured: false,
      link: '/medium-term-rentals'
    },
    {
      icon: 'ri-edit-box-line',
      title: 'Listing and setup support',
      description: 'Professional listing creation, pricing guidance, and platform setup whether you self-manage or want help.',
      featured: false,
      link: '/listing-setup'
    }
  ];

  return (
    <section id="services" className="py-24 lg:py-32 bg-[#F0F0F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <div className="text-xs font-semibold text-[#882629] uppercase tracking-widest mb-4">
            What we offer
          </div>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] max-w-2xl">
            Our services
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {services.map((service, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl p-10 shadow-md hover:shadow-xl transition-all ${service.featured ? 'md:row-span-1 md:scale-105' : ''}`}
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-[#882629] text-4xl`} style={{ strokeWidth: '2px' }}></i>
              </div>
              <h3 className="text-xl font-semibold text-[#505A5A] mb-4">
                {service.title}
              </h3>
              <p className="text-base text-[#505A5A]/70 leading-relaxed mb-6">
                {service.description}
              </p>
              <button 
                onClick={() => window.REACT_APP_NAVIGATE(service.link)}
                className="text-[#882629] text-sm font-medium flex items-center gap-2 hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
              >
                Learn more
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-[#882629] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#6E1F22] transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
          >
            Talk to us about your property
          </button>
        </div>
      </div>
    </section>
  );
}
